import { render, staticRenderFns } from "./TermometriaProdutoListaPrecos.vue?vue&type=template&id=1c8564e2&"
import script from "./TermometriaProdutoListaPrecos.vue?vue&type=script&lang=js&"
export * from "./TermometriaProdutoListaPrecos.vue?vue&type=script&lang=js&"
import style0 from "./TermometriaProdutoListaPrecos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports